import {Dealers} from "./types/Dealers";
import {filterDealers, renderDealersList} from "./functions/dealersFunctions";
import {createDealersGeoJSON, initMap} from "./functions/mapFunctions";

/**
 * Declaring the Dealers Data
 */
declare const dealersData: Dealers;

document.addEventListener("DOMContentLoaded", () => {

	// Checking if the Dealers have been loaded (using wp_localize_script)
	if (!dealersData || dealersData.length === 0) {
		return;
	}

	// Looking for the necessary section
	const dealersSectionEl = document.querySelector(".dealers-section");
	if (!dealersSectionEl) {
		return;
	}

	const dealersSectionSearchInputWrapperEl = dealersSectionEl.querySelector(".dealers-section-search");
	if (!dealersSectionSearchInputWrapperEl) {
		return;
	}

	const dealersSectionSearchInputEl = dealersSectionSearchInputWrapperEl.querySelector<HTMLInputElement>("#dealers-search");
	if (!dealersSectionSearchInputEl) {
		return;
	}

	// Adding Event Listeners
	dealersSectionSearchInputEl.addEventListener("focus", () => {
		dealersSectionSearchInputWrapperEl.classList.add("dealers-section-search_focused");
	});

	dealersSectionSearchInputEl.addEventListener("blur", () => {
		dealersSectionSearchInputWrapperEl.classList.remove("dealers-section-search_focused");
	});

	// Creating Dealers GeoJSON Object
	const dealersGeoJSON = createDealersGeoJSON(dealersData);

	// Initializing the Map
	const mapInstance = initMap(dealersGeoJSON);
	renderDealersList(dealersData, mapInstance);

	const dealersSearchInputEl = document.getElementById('dealers-search');
	if (!dealersSearchInputEl) {
		return;
	}

	dealersSearchInputEl.addEventListener('input', ev => {
		if (!ev.target) {
			return;
		}

		filterDealers((ev.target as HTMLInputElement).value, dealersData, mapInstance);
	});
})
